import React from 'react';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';

interface BackButtonProps {
  url: string;
  dataCy?: string;
  label?: string;
}

const RedirectButton: React.FC<BackButtonProps> = ({ dataCy, label, url }) => {
  const { t } = useTranslation();

  return (
    <Button
      text={label || t('pages.confirm.back')}
      type="primary"
      href={url}
      data-cy={dataCy}
    />
  );
};

export default RedirectButton;
